export default "/public/app-main/static/image/4ab07bfb540deda7888701ece74b85d0.png";